import axios from 'axios'

const baseUrl = '/api/v2/me/minhas-vendas/sales'

const header = {
  'x-minhas-vendas': true
}

export default class Sales {
  /**
   * @param  {object} params
   * @param  {Function} callback
   * @return {object} payload
   */
  static retrieve(params, callback) {
    axios.get(`${baseUrl}`, {
      params: params
    }).then(response => callback(response))
  }

  /**
   * @param {*} id
   * @param {*} payload
   * @param {*} callback
   */
  static update(id, payload, callback) {
    axios.patch(`${baseUrl}/${id}`, payload).then(response => callback(response))
  }

  /**
   * @param {*} id
   * @param {*} callback
   */
  static archive(id, callback) {
    axios.patch(`${baseUrl}/${id}/archive`).then(callback)
  }

  /**
   * @param {*} postalCode
   * @param {*} callback
   */
  static verifyPostalCode(postalCode, callback) {
    axios.get(`https://location.melhorenvio.com/${postalCode}`, {
      headers: {
        'Access-Control-Allow-Origin': '*'
      }
    }).then(response => callback(response)).catch(err => callback(err.response))
  }
}
